import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { type TransferRequestUpdateStatusRequest, type TransferRequestResponse, TransferRequestsApi, RestApiError } from '@shared/api';

const updateStatusEffect = createEffect((request: TransferRequestUpdateStatusRequest) => TransferRequestsApi.updateStatus(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestResponse | null>(null)
  .on(updateStatusEffect.done, (_, values) => values.result.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateStatusEffect.pending, (_, data) => data)
  .on(updateStatusEffect.fail, () => false)
  .on(updateStatusEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(updateStatusEffect, () => null)
  .on(updateStatusEffect.fail, (_, data) => {
    if (data.error.message === 'Invalid code, try again') return '';
    if (RestApiError.isRestApiError(data.error) && data.error.data.errorCode) return data.error.message;
    return 'Something went wrong while updating Status. Please try again.';
  })
  .on(updateStatusEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $transferUpdateStatusStore = {
  events: {
    updateStatus: updateStatusEffect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
